import React from "react";

import { Img } from "src/app/components/Img/Img";
import creatorPlaceholder from "src/images/creator-placeholder.svg";

import "./OverlapCreatorBox.scss";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { formatNumber, splitPercents } from "src/utils/methods";

export const OverlapCreatorBox = (props) => {
  const { data } = props;

  const { creator } = data;

  return (
    <div className="overlap-creator-box">
      <div className="overlap-creator-box__info">
        <Img
          src={creator?.avatar?.thumbnails?.tiny}
          fallbackImageSrc={creatorPlaceholder}
          alt="creator"
        />
        {creator?.username}
      </div>

      <table className="overlap-creator-box__stats">
        <thead>
          <th>
            <IDHFormattedMessage id="ws_followers" defaultMessage="Followers" />
          </th>
          <th>
            <IDHFormattedMessage
              id="ws_overlapping"
              defaultMessage="Overlapping"
            />
          </th>
          <th>
            <IDHFormattedMessage id="ws_unique" defaultMessage="Unique" />
          </th>
        </thead>
        <tbody>
          <tr>
            <td>{formatNumber(creator.followers)}</td>
            <td>{splitPercents(creator.overlappingPercentage)}%</td>
            <td>{splitPercents(creator.uniquePercentage)}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
